import React, { useState } from "react";
import ModalVideo from "react-modal-video";
import { Parallax } from "react-parallax";

function HowItWorks() {
  const [isOpen, setIsOpen] = useState(false);
  const videoId = "PMNnEEEacCg";
  return (
""
  );
}

export default HowItWorks;
